
import { Component, Vue } from 'vue-property-decorator'
import { KeepAlive } from '@/utils/decorators'
import Details from './WorkerDetails.vue'

@KeepAlive
@Component({
  name: 'MyOrder',
  components: {
    Details
  },
  filters: {
    getStatusName: function (value: any) {
      if (value) {
        if (value === '1') {
          return '正常'
        } else {
          return '异常'
        }
      }
    },
    getStatusName2: function (value: any) {
      if (value) {
        if (value === '1') {
          return '正常'
        } else if (value === '2') {
          return '缺上班签到'
        } else if (value === '3') {
          return '缺下班签到'
        } else if (value === '4') {
          return '上下班人数不一致'
        } else {
          return '--'
        }
      }
    }
  }
})
export default class MyOrder extends Vue {
  private searchInfo = {
    projectId: '',
    attendanceDate: '',
    workerName: ''
  }

  private total = 0
  private page = 1
  private size = 10
  private loading = false
  private tableData = []

  private id = ''
  private detailsShow = false

  get projectList () {
    return this.$store.state.projectList
  }

  created () {
    this.loadData()
  }

  loadData () {
    // console.log('loadData')
    this.loading = true
    this.$axios.get(this.$apis.laborManage.selectYhSingleAttendanceByPage,
      {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then(res => {
      this.tableData = res.list || []
      this.total = res.total || 0
    }).finally(() => {
      this.loading = false
    })
  }

  onSearch () {
    this.page = 1
    this.loadData()
  }

  onExport () {
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    this.$axios.downloadFile(this.$apis.recruitUse.exportWorkerDutyCount, this.searchInfo).finally(() => {
      loading.close()
    })
  }

  onDetail (id: any) {
    this.id = id
    this.detailsShow = true
  }
}
